@if (isLoading()) {
  <div class="social-wall__loading">
    <mat-spinner [diameter]="70"></mat-spinner>
  </div>
}

@if (!isLoading() && !cards().length) {
  <div class="social-wall__empty">
    <div class="social-wall__empty-icon">
      <lib-icon icon="chat-teardrop-text" [size]="24"></lib-icon>
    </div>
    <span class="social-wall__empty-title">{{ 'SOCIAL_WALL.no_posts_title' | translate }}</span>
  </div>
}

@if (cards().length && columnCount()) {
  <div class="social-wall" [class.social-wall--measuring]="!isSettled()">
    @for (column of columns(); track $index) {
      <div class="social-wall__column">
        @for (card of column; track card.key) {
          <div class="social-wall__item" #cardElement [attr.data-key]="card.key">
            <lib-social-wall-card [item]="card.item" [contextTemplate]="contextTemplate()" (open)="openDetail(card.index)" (like)="onCardLike(card.item)" (pin)="onCardPin(card.item)" (openLinkedContent)="linkedContentClick.emit($event)"></lib-social-wall-card>
          </div>
        }
      </div>
    }
  </div>

  @if (hasMorePosts()) {
    <div #loadMoreSentinel class="social-wall__sentinel">
      @if (isLoadingMorePosts()) {
        <mat-spinner [diameter]="32"></mat-spinner>
      }
    </div>
  }
}
